import React from 'react';
import { Button, Form, Input, Space } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface SubcategoryForm {
  nameRu: string;
  nameKy: string;
  isEditing?: boolean;
}

interface ProductVarietiesProps {
  currentForm: SubcategoryForm;
  savedForms: SubcategoryForm[];
  onCurrentFormChange: (field: keyof SubcategoryForm, value: string) => void;
  onSavedFormChange: (index: number, field: keyof SubcategoryForm, value: string) => void;
  onAddSubcategory: () => void;
  onRemoveSubcategory: (index: number) => void;
  onToggleEdit: (index: number) => void;
  onSaveChanges: (index: number) => void;
}

export const ProductVarieties: React.FC<ProductVarietiesProps> = ({
  currentForm,
  savedForms,
  onCurrentFormChange,
  onSavedFormChange,
  onAddSubcategory,
  onRemoveSubcategory,
  onToggleEdit,
  onSaveChanges
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <h4 style={{ margin: '0 0 8px 0' }}>{t('handbooks.types_of_products.Product Grade')}</h4>
      <Space style={{ width: '100%', display: 'flex', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', gap: 8, flex: 1 }}>
          <Form.Item
            style={{ margin: 0, flex: 1 }}
            rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
          >
            <Input
              value={currentForm.nameRu}
              onChange={(e) => onCurrentFormChange("nameRu", e.target.value)}
              placeholder={t("general.nameRu")}
            />
          </Form.Item>

          <Form.Item style={{ margin: 0, flex: 1 }}>
            <Input
              value={currentForm.nameKy}
              onChange={(e) => onCurrentFormChange("nameKy", e.target.value)}
              placeholder={t("general.nameKy")}
            />
          </Form.Item>
        </div>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onAddSubcategory}
        />
      </Space>

      <div style={{ marginTop: 16 }}>
        {savedForms.map((form, index) => (
          <Space
            key={index}
            style={{
              width: '100%',
              marginBottom: 8,
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ display: 'flex', gap: 8, flex: 1 }}>
              <Form.Item
                style={{ margin: 0, flex: 1 }}
                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
              >
                <Input
                  value={form.nameRu}
                  onChange={(e) => onSavedFormChange(index, "nameRu", e.target.value)}
                  disabled={!form.isEditing}
                />
              </Form.Item>

              <Form.Item style={{ margin: 0, flex: 1 }}>
                <Input
                  value={form.nameKy}
                  onChange={(e) => onSavedFormChange(index, "nameKy", e.target.value)}
                  disabled={!form.isEditing}
                />
              </Form.Item>
            </div>

            <Space>
              <Button
                type={form.isEditing ? "primary" : "text"}
                icon={form.isEditing ? <SaveOutlined /> : <EditOutlined />}
                onClick={() => form.isEditing ? onSaveChanges(index) : onToggleEdit(index)}
              />
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => onRemoveSubcategory(index)}
              />
            </Space>
          </Space>
        ))}
      </div>
    </div>
  );
};
